import React from 'react';

export default function Component(props) {

const { question, answersList,SurveyAttributes, ansTextBoxChange1, surveyScreenData, themeObj } = props;

return(
    <>
            <div className="py-6 w-11/12 ml-2 lg:text-base text-sm font-normal  mb-4 gap-3 mr-auto lg:w-11/12">
              <div className="w-full">
                <textarea 
                rows={1} cols={50}
                value={(answersList && answersList.length > 0 && answersList
                  .findIndex(item => item.questionId === question.id) !== -1) ?
                  answersList[answersList.findIndex(item => item.questionId === question.id)].answer1
                  : ''}
                onChange={(event)=>ansTextBoxChange1(event,question)} 
                style={{borderColor:themeObj["optionBorderColor"], color:themeObj["textColor"]}}
                className={ "p-2 bg-transparent focus:outline-none border-b  placeholder-["+themeObj["textColor"]+"] text-lg w-full border-opacity-50 focus:border-opacity-100 focus:border-b-2" }
                placeholder={SurveyAttributes("WriteHereText")?SurveyAttributes("WriteHereText"):"Write here"}
                /></div>
            </div>



    </>
  );}